import { useEffect, useMemo, useState } from 'react';
import { StyledLeadContainer, CreateLeadFooter, StyledSubHeader, StyledGridContainer, } from '../../Components/Styled/index';
import { Box, Button, Stack, Typography } from '@mui/material';
import { privateRoutesPath } from '../../Routes';
import { useSnackbar } from 'notistack';
import { useSelector, useDispatch } from 'react-redux';
import { useRef } from 'react';
import BiztantuLoader from '../../Components/Loader';
import { requestShowLoader, requestHideLoader } from '../../Store/Global/action';
import { ACTIVE_STATUS, ADDITIONAL_ATTRIBUTE_FIELDS, handleValidateCodevalue, PRODUCT_STATUS, PRODUCT_TYPE, PRODUCT_UOM, searchEntity, STATIC_ENTITY_CONFIG } from '../../Utility/constant';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import { EntityNote } from '../../Components/EntityNote';
import AutoCompleteComponent from '../../Components/AutoCompleteComponenet';
import { createRequestData, getEntityColumns, validateFields } from '../../Utility/apiHelper';
import { formatAdditionalAttributesForPayload } from '../../Utility/payloadFormatter';
import CustomizableFields from '../../Components/CustomizableFields';
import { requestGetAllMerchant } from '../../Store/Merchant/action';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import useNavigation from '../../Utility/hooks/useNavigation';
import './product.css';
const CreateProduct = ({ }) => {
    const location = useLocation();
    const [productDetail, setProductDetail] = useState({
        status : "PRODUCT_STATUS_ACTIVE"
    });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isRequired, setRequired] = useState(false);
    const merchantData = useSelector(state => state?.merchant?.merchant);
    const inputRef = useRef(null);
    const dispatch = useDispatch();
    const handleChangeLeadData = (event) => {
        setProductDetail({
            ...productDetail,
            [event.target.name]: event.target.value
        })
    }
    const productTypeData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == PRODUCT_TYPE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const productStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == PRODUCT_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const productUOMData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == PRODUCT_UOM)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const allEntityData = useSelector((state) => state?.customization?.allEntityData || []);
    const productTextfieldsData = useMemo(() => {
            const data = getEntityColumns(allEntityData, "PRODUCT");
            const {id,status ,...rest} = Object.keys(data).length > 0 ?  data : STATIC_ENTITY_CONFIG?.PRODUCT;
    
            return rest
        }, [allEntityData]);

    const { navigateTo, goBackTo,openInNewTab } = useNavigation();

    useEffect(()=>{
        dispatch(requestGetAllMerchant());     
    },[])
    const isLoadingProgress = useSelector(state => state.global?.isLoading);
    const handleSaveProduct = async () => {

        const {errors,hasError} = validateFields(productTextfieldsData, productDetail);
            if (hasError) {
                setRequired(errors);
                enqueueSnackbar(
                    handleValidateCodevalue(internationalise, "COMMON_MSG_MANDATORY_FIELDS"),
                { variant: "error" }
                );
                return;
            } else {
            const reqPayload = formatAdditionalAttributesForPayload(
                {
                   ...productDetail,
                },
                ADDITIONAL_ATTRIBUTE_FIELDS
            );
            
            dispatch(requestShowLoader());
            try {
                const response = await createRequestData(reqPayload,"products");
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_CREATED_SUCCESSFULLY"), { variant: 'success' });


                navigateTo(`${privateRoutesPath.EDIT_PRODUCT}/${response?.data?.id}`);
           
            } catch (error) {
                enqueueSnackbar(handleValidateCodevalue(internationalise,error?.response?.data?.message || "COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });
            } finally {
                dispatch(requestHideLoader());
            }
        }
        

    }


    
    const handleSelectCompany =(e,val,entity)=>{
        if(entity === "Vendor"){
        setProductDetail({
            ...productDetail,
            selectedVendor : val,
            vendorId : val?.id
        })
    }
       
    }
    const goBack = () => goBackTo(privateRoutesPath.PRODUCT,searchEntity?.product);
    return (
        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
             <Box className='globalBox'>
                {/* <Typography variant='h6' gutterBottom>
                {handleValidateCodevalue(internationalise,'PROD_EDIT_TITLE_CREATE')}
                </Typography> */}
            
                <StyledSubHeader>
                     {handleValidateCodevalue(internationalise,'PROD_EDIT_PRODUCT_DETAILS')}
                </StyledSubHeader>

                <StyledGridContainer>
                    <TextFiledWithLabel
                        name="name"
                        required={true}
                        error={ productDetail?.name ? false : isRequired?.name}
                        inputRef={inputRef}
                        label={handleValidateCodevalue(internationalise,'PROD_EDIT_PRODUCT_NAME')}
                        handleOnChange={handleChangeLeadData}
                        value={productDetail?.name}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <SelectBoxWithLabel
                        ownerdropdown={false}
                        disabled
                        name= "status"
                        error={ productDetail?.status ? false : isRequired?.status}
                        value= {productDetail?.status || ""}
                        isStatic={false}
                        optionMenuItem={productStatusData}
                        label={handleValidateCodevalue(internationalise,'PRODUCT_STATUS')}
                        handleOnChange={handleChangeLeadData}
                    />
                    </StyledGridContainer>
                    <StyledLeadContainer className="product-description-container">
                    <TextFiledWithLabel
                        className="product-description-field"
                        name="description"
                        label={handleValidateCodevalue(internationalise,'PROD_EDIT_DESCRIPTION')}
                        handleOnChange={handleChangeLeadData}
                        value={productDetail?.description}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    </StyledLeadContainer>
                <StyledGridContainer>
                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        required = {true}
                        error={ productDetail?.type ? false : isRequired?.type}
                        value={productDetail?.type}
                        name="type"
                        label={handleValidateCodevalue(internationalise,'PRODUCT_TYPE')}
                        handleOnChange={handleChangeLeadData}
                        optionMenuItem={productTypeData}
                        isStatic={false}
                    />
                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        error = {productDetail?.unitOfMeasurement? false : isRequired?.unitOfMeasurement}
                        required = {true}
                        name= "unitOfMeasurement"
                        value= {productDetail?.unitOfMeasurement || ""}
                        isStatic={false}
                        optionMenuItem={productUOMData}
                        label={handleValidateCodevalue(internationalise,'PRODUCT_UOM')}
                        handleOnChange={handleChangeLeadData}
                    />
                    {(productTextfieldsData?.selectedVendor?.visibility && specificRolePermission?.isVendorView) &&
                    <AutoCompleteComponent
                    optionSet = {merchantData}
                    value={productDetail?.selectedVendor || null}
                    error = {productDetail?.selectedVendor? false : isRequired?.selectedVendor}
                    name = "vendorId"
                    required={productTextfieldsData?.selectedVendor?.mandatory}
                    placeholder={handleValidateCodevalue(internationalise,'PROD_EDIT_VENDOR')}
                    label={handleValidateCodevalue(internationalise,'PROD_EDIT_VENDOR')}       
                    onChange={(e, val) => handleSelectCompany(e, val, "Vendor")}
                    />
                    }
                 </StyledGridContainer>
                 <StyledSubHeader>
                     {handleValidateCodevalue(internationalise,'PROD_EDIT_PRICING')}
                </StyledSubHeader>
                <StyledGridContainer>
                    
                    {productTextfieldsData?.mrp?.visibility &&
                    <TextFiledWithLabel
                        id="mrp"
                        name="mrp"
                        type = "number"
                        error = {productDetail?.mrp? false : isRequired?.mrp}
                        required={productTextfieldsData?.mrp?.mandatory}
                        value={productDetail?.mrp}
                        handleOnChange={handleChangeLeadData}
                        label={handleValidateCodevalue(internationalise,'PROD_EDIT_MRP')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    }
                    
                        <TextFiledWithLabel
                            id="sellingPrice"
                            type = "number"
                            name="sellingPrice"
                            required={true}
                            error = {productDetail?.sellingPrice ? false : isRequired?.sellingPrice}
                            value={productDetail?.sellingPrice}
                            handleOnChange={handleChangeLeadData}
                            label={handleValidateCodevalue(internationalise, 'PROD_EDIT_SP')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    
                    {productTextfieldsData?.discount1Percentage?.visibility &&
                    <TextFiledWithLabel
                        id="discount1Percentage"
                        type = "number"
                        name="discount1Percentage"
                        error = {productDetail?.discount1Percentage ? false : isRequired?.discount1Percentage}
                        required={productTextfieldsData?.discount1Percentage?.mandatory}
                        value={productDetail?.discount1Percentage}
                        handleOnChange={handleChangeLeadData}
                        label={handleValidateCodevalue(internationalise, 'PROD_EDIT_DISCOUNT1_PERCENT')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    }

                    {productTextfieldsData?.discount2Percentage?.visibility &&
                    <TextFiledWithLabel
                        id="discount2Percentage"
                        type = "number"
                        name="discount2Percentage"
                        error = {productDetail?.discount2Percentage ? false : isRequired?.discount2Percentage}
                        required={productTextfieldsData?.discount2Percentage?.mandatory}
                        value={productDetail?.discount2Percentage}
                        handleOnChange={handleChangeLeadData}
                        label={handleValidateCodevalue(internationalise, 'PROD_EDIT_DISCOUNT2_PERCENT')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    }

                    {productTextfieldsData?.discount3Percentage?.visibility &&
                    <TextFiledWithLabel
                        id="discount3Percentage"
                        type = "number"
                        name="discount3Percentage"
                        error = {productDetail?.discount3Percentage ? false : isRequired?.discount3Percentage}
                        required={productTextfieldsData?.discount3Percentage?.mandatory}
                        value={productDetail?.discount3Percentage}
                        handleOnChange={handleChangeLeadData}
                        label={handleValidateCodevalue(internationalise, 'PROD_EDIT_DISCOUNT3_PERCENT')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    }
                    <TextFiledWithLabel
                        id="cgstPercentage"
                        type = "number"
                        name="cgstPercentage"
                        value={productDetail?.cgstPercentage}
                        handleOnChange={handleChangeLeadData}
                        label={handleValidateCodevalue(internationalise, 'PROD_EDIT_CGST_PERCENT')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextFiledWithLabel
                        id="sgstPercentage"
                        type = "number"
                        name="sgstPercentage"
                        value={productDetail?.sgstPercentage}
                        handleOnChange={handleChangeLeadData}
                        label={handleValidateCodevalue(internationalise, 'PROD_EDIT_SGST_PERCENT')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    
                    {productTextfieldsData?.surchargePercentage?.visibility &&
                    <TextFiledWithLabel
                        id="surchargePercentage"
                        type = "number"
                        name="surchargePercentage"
                        error = {productDetail?.surchargePercentage ? false : isRequired?.surchargePercentage}
                        value={productDetail?.surchargePercentage}
                        required={productTextfieldsData?.surchargePercentage?.mandatory}
                        handleOnChange={handleChangeLeadData}
                        label={handleValidateCodevalue(internationalise, 'PROD_EDIT_SURCHARGE_PERCENT')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    }
                </StyledGridContainer>

            <CustomizableFields
                CUSTOMIZABLE_FIELDS={ADDITIONAL_ATTRIBUTE_FIELDS}
                entity = "PRODUCT"
                config={productTextfieldsData}
                values={productDetail}
                setValues={setProductDetail}
                handleOnChange={handleChangeLeadData}
                errors={isRequired}
                />

        <EntityNote
        entityDetails = {productDetail} 
        onChange = {handleChangeLeadData}
        headingLabel = {handleValidateCodevalue(internationalise,"COMMON_SPECIAL_NOTE")}
        />

                {/* <DocumentManagement
                    documentlabel = {handleValidateCodevalue(internationalise,'PRODUCT_DOCUMENT_LAYOUT')}
                /> */}

                {/* <StyledSubHeader>
                     Product Floor Layout 
                </StyledSubHeader>
                
                <StyledFlexStart>
                            <input type="file" name="floorlayout" handleOnChange={handleSelectFloorImage}/>
                </StyledFlexStart> */}
            </Box>
            <CreateLeadFooter>
                <Stack alignItems="center" display={"flex"} justifyContent={"space-between"} flexDirection={"row"}>
                    <Typography variant='h6'>
                        {handleValidateCodevalue(internationalise,'PROD_EDIT_TITLE_CREATE')}
                    </Typography>
                <Button className='edit-primary btn-space' variant="outlined" onClick={goBack}>{handleValidateCodevalue(internationalise,'COMMON_BACK')}</Button>
                <Button className='edit-primary' variant="outlined" onClick={handleSaveProduct}>{handleValidateCodevalue(internationalise,'COMMON_SAVE')}</Button>
                </Stack>
            </CreateLeadFooter>
        </BiztantuLoader>
    )
}

export default CreateProduct;